import type { FormLocale } from '@jlg-website/shared';
import { ConfirmButton } from '../shared/confirm-button';
import { formatCountdown } from '../shared/confirm-deadline';
import { textFor } from '../shared/copy';
import { formatScheduleSummary } from '../shared/date-time';
import { NotesField } from '../shared/notes-field';
import { StepBackButton } from '../shared/step-back-button';
import { SummaryRow } from '../shared/summary-row';
import type { CallbackSlot } from './type';

type ConfirmStepProps = {
  date: string;
  slot: CallbackSlot;
  timeZone: string;
  phone: string;
  notes: string;
  locale: FormLocale;
  /** Time left to confirm before the picked slot is too close to start to be booked. */
  remainingMs: number;
  submitting: boolean;
  onChangeNotes: (notes: string) => void;
  onChangeSchedule: () => void;
  onBack: () => void;
  onConfirm: () => void;
};

export function ConfirmStep({
  date,
  slot,
  timeZone,
  phone,
  notes,
  locale,
  remainingMs,
  submitting,
  onChangeNotes,
  onChangeSchedule,
  onBack,
  onConfirm,
}: ConfirmStepProps) {
  return (
    <div className="flex flex-col gap-4">
      {/* No title of its own: the progress header above the step already carries it. */}
      <StepBackButton onClick={onBack} label={textFor(locale, 'backToTimes')} />

      <SummaryRow
        summary={formatScheduleSummary(locale, date, slot.label, timeZone)}
        locale={locale}
        onChange={onChangeSchedule}
      />

      <p className="text-sm text-brand-primary">
        {textFor(locale, 'weWillCall')} <strong className="font-bold">{phone}</strong>.
      </p>

      <p role="timer" className="text-sm text-gray-light">
        {textFor(locale, 'deadline').replace('{time}', formatCountdown(remainingMs))}
      </p>

      <NotesField id="callback-notes" notes={notes} locale={locale} onChange={onChangeNotes} />

      <ConfirmButton locale={locale} disabled={submitting} onClick={onConfirm} />
    </div>
  );
}
